module.exports = __webpack_public_path__ + "img/iso.d8b4d28f.png";